import styled from 'styled-components';
import { Form, Typography } from 'antd';

export const RepeatingTaskText = styled(Typography.Text)`
  &.ant-typography {
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
  }
`;

export const FrequencyText = styled(Typography.Text)`
  &.ant-typography {
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
    text-transform: capitalize;
  }
`;

export const EveryText = styled(Typography.Text)`
  &.ant-typography {
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
    text-transform: lowercase;
  }
`;

export const ScheduleEndDateText = styled(Typography.Text)`
  &.ant-typography {
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
    text-transform: capitalize;
  }
`;

export const OptionalText = styled(Typography.Text)`
  &.ant-typography {
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_SECONDARY};
  }
`;

export const DaySelectionText = styled(Typography.Text)`
  &.ant-typography {
    font-weight: ${({ theme: { kcc } }): number => kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${({ theme: { kcc } }): number => kcc.typography.LINE_HEIGHT.BASE};
    text-transform: capitalize;
  }
`;

export const RepeatingTaskFormItem = styled(Form.Item)`
  margin: 0;
  width: 100%;

  .ant-form-item-explain-error {
    position: absolute;
    margin-top: 2px;
  }

  &.repeating-task-weekdays {
    .ant-form-item-explain-error {
      position: static;
      margin-top: ${({ theme: { kcc } }): string => kcc.spacing.XXS};
    }

    &.ant-form-item-has-error {
      margin-bottom: ${({ theme: { kcc } }): string => kcc.spacing.SM};
    }
  }

  input::placeholder {
    color: ${({ theme: { kcc } }): string => kcc.colors.TEXT_PLACEHOLDER};
  }

  .schedule-frequency-active-border:not(.ant-select-disabled),
  .schedule-select-active-border:not(.ant-select-disabled) {
    .ant-select-selector {
      border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE};
    }
  }

  .ant-input-number-affix-wrapper:not(.ant-input-number-disabled) {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE};
  }

  .ant-picker {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_SECONDARY};

    .ant-picker-suffix {
      width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
      height: ${({ theme: { kcc } }): number => kcc.size.S250}px;

      svg {
        width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
        height: ${({ theme: { kcc } }): number => kcc.size.S250}px;
      }
    }
  }

  .ant-input-status-success,
  .ant-picker-status-success,
  .schedule-picker-active-border:not(.ant-picker-disabled) {
    border-color: ${({ theme: { kcc } }): string => kcc.colors.BORDER_ACTIVE} !important;
  }

  .ant-select-arrow {
    width: ${({ theme: { kcc } }): number => kcc.size.S250}px;

    svg {
      width: ${({ theme: { kcc } }): number => kcc.size.S250}px;
    }
  }
`;
